<template>
  <div>
    <v-autocomplete
      :loading="isLoading"
      placeholder="Search Medical Codes"
      :items="codes"
      item-value="medical_code"
      item-text="medical_code"
      v-model="code"
      clearable
      :search-input.sync="filter"
      :filter="filterObject"
      hide-no-data
      hide-selected
      @change="addToFavorite"
    >
      <template v-slot:append>
        <v-icon>mdi-magnify</v-icon>
      </template>

      <template v-slot:append-item>
        <hr style="border-top: 1px solid #cccccc" />

        <div class="d-flex mt-3 mb-1">
          <v-btn
            small
            depressed
            rounded
            color="primary"
            class="mx-2 px-4 text-none"
            @click="togglePage('prev')"
            :disabled="page == 1"
          >
            Prev
          </v-btn>

          <v-spacer style="text-align: center"
            >Page {{ page }} / {{ last_page }}</v-spacer
          >

          <v-btn
            small
            depressed
            rounded
            color="primary"
            class="mx-2 px-4 text-none"
            @click="togglePage('next')"
            :disabled="last_page == page"
          >
            Next
          </v-btn>
        </div>
      </template>

      <template v-slot:item="data">
        <!-- medicine item -->
        <DiagnosisItem :item="data.item" width="widthInherit" style="width: 100px;"/>
      </template>
    </v-autocomplete>

    <v-data-table
      :items="favoriteCodes"
      class="sticky mt-5"
      :disable-sort="true"
      :headers="headers"
    >
      <template v-slot:item="{ item }">
        <tr>
          <!-- Row Name -->
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-black">
                  {{ item.medical_code }}
                </v-list-item-title>
                <v-list-item-title class="text-wrap">
                  {{ item.description }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn dense icon>
                    <v-icon
                      large
                      :color="'yellow darken-2'"
                      @click.stop="updateFavorites(item)"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import DiagnosisItem from '../../Dashboard/components/form/DiagnosisItem';

export default {
  name: "Diagnosis",

  components: { DiagnosisItem },

  watch: {
    async filter(val) {
      try {
        this.isLoading = true;
        await this.$store.dispatch("diagnosis/searchCode", val);
        this.isLoading = false;
        this.page = 1;
      } catch (e) {
        console.log("[error]", e);
        this.isLoading = false;
      }
    },
  },

  computed: {
    favoriteCodes() { return this.$store.getters["diagnosis/fave_codes"]; },
    codes() { return this.$store.getters["diagnosis/codes"]; },
    last_page() { return this.$store.getters['diagnosis/last_page'] },
  },

  async mounted() {
    await this.$store.dispatch("diagnosis/getFavoritesMedicalCodes");
  },

  data() {
    return {
      headers: [
        { text: "Code", value: "code" },
        { text: "", value: "", class: "", width: "100px" },
      ],
      isLoading: false,
      filter: "",
      code: "",
      page: 1,
    };
  },

  methods: {

    addToFavorite () {
      let index = this.codes.findIndex(
        item => item.medical_code == this.code
      )
      
      if (index >= 0) {
        this.$store.dispatch("diagnosis/updateFavorites", this.codes[index]);
      }
    },

    async togglePage(type) {
      let params = {};

      if (this.filter != null && this.filter.length > 0) {
        params = { per_page: 10, page: this.page, search: this.filter };
      } else {
        params = { per_page: 10, page: this.page };
      }

      if (type == "next") {
        if (this.last_page > this.page) {
          this.page++;
          params.page++;
          await this.$store.dispatch("diagnosis/fetchCodes", params);
        }
      } else {
        this.page--;
        params.page--;
        await this.$store.dispatch("diagnosis/fetchCodes", params);
      }
    },

    async updateFavorites(item) {
      this.$store.dispatch("diagnosis/updateFavorites", item);
    },

    filterObject(item, queryText) {
      return (
        item.description
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.medical_code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
  },
};
</script>